import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Merge Detail|IDs|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.MergeCandidates,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityMergeDetailsIds';
export type SPCandidateSystemActivityMergeDetailsIdsLocNames =
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelCreated`;

export const spCandidateSystemActivityMergeDetailsIdsLocs: LocDefs<SPCandidateSystemActivityMergeDetailsIdsLocNames> =
	{
		SPCandidateSystemActivityMergeDetailsIdsLabelDataProvider: {
			defaultValue: 'Data Provider',
			description: 'Label for: Data Provider.',
			displayPath: `${pathStart}Data Provider`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.IDTable.ColumnHeading.DataProvider',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsIdsLabelId: {
			defaultValue: 'ID',
			description: 'Label for: ID.',
			displayPath: `${pathStart}ID`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.IDTable.ColumnHeading.ExternalID',
			...sharedProperties,
		},
		SPCandidateSystemActivityMergeDetailsIdsLabelCreated: {
			defaultValue: 'Created Date',
			description: 'Label for: Created Date.',
			displayPath: `${pathStart}Created Date`,
			displayType: 'Label',
			legacyName:
				'MergeCandidates/Candidates.SystemActivity.Merges.MergeDetail.IDTable.ColumnHeading.Created',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityMergeDetailsIdsLocType =
	LocMap<SPCandidateSystemActivityMergeDetailsIdsLocNames>;
